if (!customElements.get('mega-menu-pxg')) {
  customElements.define(
    'mega-menu-pxg',
    class MegaMenuPxg extends HTMLElement {
      constructor() {
        super();
        this.secondaryNavHeight = 0;
        this.secondaryNavElement = null;
        this.setNavHeight();
        window.addEventListener('resize', this.setNavHeight.bind(this));
        // Need to check if the secondary nav is present on the page, if true then we need to calculate the offset of the secondary nav
        // and add it to the header height.
        window.elementReady('.secondary-nav-pxg', false, this.secondaryNavCheck.bind(this))
              .then(this.secondaryNavCheck.bind(this));
      }

      setNavHeight() {
        const totalHeight = Array.from(document.querySelectorAll('.js-header-height-calculation')).reduce(
          (total, nav) => total + nav.getBoundingClientRect().height,
          0
        );
        const clamp = (num, min, max) => Math.min(Math.max(num, min), max);
        this.secondaryNavHeight = Math.floor(this?.secondaryNavElement?.getBoundingClientRect()?.height) || 0;
        // This offset is used strictly for secondary nav
        document.documentElement.style.setProperty('--secondary-nav-offset', `${totalHeight}px`);
        document.documentElement.style.setProperty('--nav-height', `${clamp(totalHeight + this.secondaryNavHeight, 1, 180)}px`);
      }

      secondaryNavCheck(element) {
        this.secondaryNavElement = element;
        this.setNavHeight();
      }
    }
  );
}
